//TODO : Refactor after ai
/** The Beyond UI tone table, shared by Badge, Chip, FeaturedIcon and MapPin. */

import type { ToneColor } from "../types";

export interface Tone {
  fg: string;
  bg: string;
  solid: string;
}

export const TONE: Record<ToneColor, Tone> = {
  brand: {
    fg: "var(--brand-700)",
    bg: "var(--brand-50)",
    solid: "var(--brand-600)",
  },
  neutral: {
    fg: "var(--text-secondary)",
    bg: "var(--neutral-100)",
    solid: "var(--neutral-900)",
  },
  success: {
    fg: "var(--success-700)",
    bg: "var(--success-50)",
    solid: "var(--success-500)",
  },
  error: {
    fg: "var(--error-700)",
    bg: "var(--error-50)",
    solid: "var(--error-500)",
  },
  warning: {
    fg: "var(--warning-700)",
    bg: "var(--warning-50)",
    solid: "var(--warning-500)",
  },
  info: {
    fg: "var(--info-700)",
    bg: "var(--info-50)",
    solid: "var(--info-500)",
  },
  violet: {
    fg: "var(--violet-700)",
    bg: "var(--violet-50)",
    solid: "var(--violet-500)",
  },
};

export const toneOf = (color: ToneColor | undefined): Tone =>
  TONE[color ?? "neutral"] ?? TONE.neutral;
